import React from 'react';
import { ToastProps } from '@helpers/Models';
import { S3Assets } from '@helpers/Constants';

interface ExtendedToastProps extends ToastProps {
  type: 'success' | 'error';
}

const Toast: React.FC<ExtendedToastProps> = ({
  title,
  message,
  onClose,
  type,
}) => {
  const isSuccess = type === 'success';

  return (
    <div
      className={`z-50 fixed top-4 right-4 w-72 bg-white border rounded-lg shadow-lg ${
        isSuccess ? 'border-green-400' : 'border-red-400'
      }`}
      role="alert"
      aria-live={isSuccess ? 'polite' : 'assertive'}
    >
      {/* Header with Title and Close Button */}
      <div
        className={`flex items-center justify-between px-4 py-2 rounded-t-lg ${
          isSuccess ? 'bg-green-100' : 'bg-red-100'
        }`}
      >
        <div className="flex items-center">
          <img
            src={isSuccess ? S3Assets.successCheck : S3Assets.errorWarning}
            alt={isSuccess ? 'Success' : 'Warning'}
            className="h-5 w-5 mr-2"
          />
          <h2
            className={`font-semibold text-sm ${
              isSuccess ? 'text-green-800' : 'text-red-800'
            }`}
          >
            {title}
          </h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {/* Body with Message */}
      <div className="px-4 py-3">
        <p className="text-sm text-gray-800">{message}</p>
      </div>
    </div>
  );
};

export default Toast;
